import { call, put, takeEvery, CallEffect, PutEffect } from 'redux-saga/effects'
import { ordersActions } from './actions'
import { orderService } from '../../../services'

/**
 * Saga para buscar listagem de pedidos
 */
function* fetchOrdersSaga(action: ReturnType<typeof ordersActions.fetchOrdersRequest>): Generator<CallEffect | PutEffect, void, any> {
  try {
    const params = action.payload
    const response = yield call(orderService.list, params)
    
    yield put(ordersActions.fetchOrdersSuccess({
      orders: response.orders,
      pagination: response.pagination
    }))
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Erro ao carregar pedidos'
    yield put(ordersActions.fetchOrdersFailure({ error: errorMessage }))
  }
}

/**
 * Saga para buscar pedido por ID
 */
function* fetchOrderSaga(action: ReturnType<typeof ordersActions.fetchOrderRequest>): Generator<CallEffect | PutEffect, void, any> {
  try {
    const orderId = action.payload
    const response = yield call(orderService.getById, orderId)
    
    yield put(ordersActions.fetchOrderSuccess({
      order: response.order
    }))
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Erro ao carregar pedido'
    yield put(ordersActions.fetchOrderFailure({ error: errorMessage }))
  }
}

/**
 * Saga para cancelar pedido
 */
function* cancelOrderSaga(action: ReturnType<typeof ordersActions.cancelOrderRequest>): Generator<CallEffect | PutEffect, void, any> {
  try {
    const orderId = action.payload
    const response = yield call(orderService.cancel, orderId)
    
    yield put(ordersActions.cancelOrderSuccess({
      order: response.order
    }))
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message || 'Erro ao cancelar pedido'
    yield put(ordersActions.cancelOrderFailure({ error: errorMessage }))
  }
}

/**
 * Root saga do módulo Orders
 */
export function* ordersSaga(): Generator {
  yield takeEvery(ordersActions.fetchOrdersRequest.type, fetchOrdersSaga)
  yield takeEvery(ordersActions.fetchOrderRequest.type, fetchOrderSaga)
  yield takeEvery(ordersActions.cancelOrderRequest.type, cancelOrderSaga)
}

